<template>
  <!-- prettier-ignore -->
  <transition
    mode="out-in"
    :name="isOpen ? 'slide-up' : 'slide-down'"
    @enter="enter"
    @after-enter="afterEnter"
    @leave="leave">
    <div
      v-if="isOpen"
      v-sticky-basket="stickyBasketOptions"
      :class="classes"
      :sticky-basket-desktop="$browser.isDesktop">
      <div class="basket-overlay-info">
        <span
          class="basket-overlay-info__message"
          v-html="message">
        </span>
        <button
          type="button"
          aria-label="Close Basket Widget"
          class="basket-overlay-info__close"
          @click="$emit('close')">
          <ovp-icon
            art="light"
            name="xmark"
          />
        </button>
      </div>
      <ovp-basket-widget-person-list
        :is-compact="isCompact"
        :persons="persons"
        :readonly="readonly"
      />
      <div
        v-if="!hasProducts"
        class="basket-overlay-content">
        {{ isBasketWidget ? $t('basket.noProductsAddSome') : $t('basket.noProducts') }}
      </div>
      <div
        v-else
        class="basket-overlay-total">
        <ovp-price
          class="basket-overlay-total__price"
          :price="total"
          show-zero-value
          :suffix="$t(priceSuffix)"
        />
      </div>

      <ovp-basket-widget-action
        v-if="hasAction"
        class="basket-overlay-action"
        :has-persons="hasPersons"
        @click="$emit('action-click')"
      />

      <ovp-basket-widget-extend-toggle
        v-if="persons.length > 0"
        :is-compact="isCompact"
        @toggle="$emit('toggle-compact')"
      />
    </div>
  </transition>
</template>

<script>
import OvpBasketWidgetAction from '@/components/BasketWidget/Container/Action'
import OvpBasketWidgetExtendToggle from '@/components/BasketWidget/Container/ExtendToggle'
import OvpBasketWidgetPersonList from '@/components/BasketWidget/Container/PersonList'
import OvpPrice from '@/components/Product/Price'

import StickyBasket from '@/directives/StickyBasket'
import { StatusHelper } from '@/helpers'
import HeightTransition from '@/mixins/HeightTransition.js'

export default {
  name: 'Overlay',

  mixins: [HeightTransition],

  directives: { StickyBasket },

  components: {
    OvpBasketWidgetAction,
    OvpBasketWidgetExtendToggle,
    OvpBasketWidgetPersonList,
    OvpPrice,
  },

  props: {
    isCompact: {
      type: Boolean,
      default: false,
    },

    isManuallyOpened: {
      type: Boolean,
      default: false,
    },

    isOpen: {
      type: Boolean,
      default: false,
    },

    isWww: {
      type: Boolean,
      default: false,
    },

    isWww: {
      type: Boolean,
      default: false,
    },

    message: {
      type: String,
      default: '',
    },

    persons: {
      type: Array,
      required: true,
    },

    readonly: {
      type: Boolean,
      default: false,
    },

    total: {
      type: Number,
      default: 0,
    },
  },

  computed: {
    classes() {
      return {
        'basket-overlay': true,
        'basket-overlay__www': this.isWww,
      }
    },

    priceSuffix() {
      return this.$browser.isDesktop ? 'product.amountMonthly' : 'product.currency'
    },

    hasPersons() {
      return StatusHelper.isPersonalDataValid(this.persons)
    },

    hasProducts() {
      return StatusHelper.basketHasProducts(this.persons)
    },

    isBasketWidget() {
      return !window.ovpRouter
    },

    hasAction() {
      return this.isBasketWidget || this.hasPersons
    },

    stickyBasketOptions() {
      return {
        isOpen: this.isOpen,
        isManuallyOpened: this.isManuallyOpened,
        onClose: this.handleClose,
      }
    },
  },

  methods: {
    handleClose() {
      this.$emit('close')
    },
  },
}
</script>

<style name="animations" scoped>
.slide-down-enter-active,
.slide-down-leave-active,
.slide-up-enter-active,
.slide-up-leave-active {
  transition-duration: 0.5s;
  transition-property: height, opacity, transform;
  transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
  overflow: hidden;
}

.slide-down-enter,
.slide-up-leave-active,
.slide-down-leave-active,
.slide-up-enter {
  opacity: 0;
  height: 0;
  transform: translate(0, -2em);
}
</style>

<style name="mobile" scoped>
.basket-overlay {
  font-size: 15px;
  font-weight: bold;
  position: fixed;
  top: 65px;
  left: 0;
  right: 0;
  z-index: 801;
  padding: 15px 25px 35px;
  background-color: var(--c-white);
  border-bottom: 1px solid var(--c-light-gray);

  &__www {
    top: 45px;
  }

  &__www {
    top: 45px;
  }

  &__sticky {
    top: 0;
  }
  &-info {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    &__message {
    }
    &__close {
      background-color: inherit;
      border: none;
      cursor: default;
      z-index: 9999;
      padding: 0;

      height: 42px;
      width: 42px;
      display: flex;
      justify-content: flex-end;
      align-items: center;

      &:focus {
        outline: none;
      }

      svg {
        padding-left: 9px;
        height: 24px;
        width: 24px;
      }
    }
  }

  &-content {
    margin: 15px 0 40px;
  }

  &-total {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: baseline;
    margin-bottom: 10px;
    &__price >>> .price__value {
      font-weight: normal;
      font-size: 50px;
      line-height: 60px;
    }
  }
}
</style>

<style name="www-mobile" scoped>
@media (--sm) {
  .basket-overlay {
    &__www {
      top: 65px;
    }

    &__sticky {
      top: 0;
    }
  }
}
</style>

<style name="desktop" scoped>
@media (--md) {
  .basket-overlay {
    position: absolute;
    top: 45px;
    left: initial;
    right: 0;
    width: 390px;
    border: 1px solid var(--c-light-gray);

    &&__sticky-desktop {
      top: 0;
      left: initial;
      right: 24px;
      position: fixed;
    }
  }
}
</style>